
export const casinoQuizQuestions = [
  {
    id: 1,
    question: 'Какой размер бонуса для вас наиболее важен?',
    options: [
      { id: 'a', text: 'Максимальный приветственный бонус', points: { bonus: 3, speed: 0, games: 0, mobile: 0 } },
      { id: 'b', text: 'Регулярные бонусы и кэшбэк', points: { bonus: 2, speed: 0, games: 1, mobile: 0 } },
      { id: 'c', text: 'Бонусы не важны, главное — честная игра', points: { bonus: 0, speed: 1, games: 2, mobile: 0 } }
    ]
  },
  {
    id: 2,
    question: 'Как быстро вы хотите получать выигрыши?',
    options: [
      { id: 'a', text: 'Мгновенно (до 15 минут)', points: { bonus: 0, speed: 3, games: 0, mobile: 0 } },
      { id: 'b', text: 'В течение часа', points: { bonus: 0, speed: 2, games: 0, mobile: 0 } },
      { id: 'c', text: 'В течение суток — не критично', points: { bonus: 1, speed: 0, games: 1, mobile: 0 } }
    ]
  },
  {
    id: 3,
    question: 'Какие игры вы предпочитаете?',
    options: [
      { id: 'a', text: 'Слоты и автоматы', points: { bonus: 1, speed: 0, games: 3, mobile: 1 } },
      { id: 'b', text: 'Настольные игры (рулетка, блэкджек)', points: { bonus: 0, speed: 0, games: 2, mobile: 0 } },
      { id: 'c', text: 'Live казино с живыми дилерами', points: { bonus: 0, speed: 1, games: 3, mobile: 0 } },
      { id: 'd', text: 'Всё понемногу', points: { bonus: 1, speed: 1, games: 2, mobile: 1 } }
    ]
  },
  {
    id: 4,
    question: 'С какого устройства вы чаще играете?',
    options: [
      { id: 'a', text: 'Смартфон', points: { bonus: 0, speed: 1, games: 0, mobile: 3 } },
      { id: 'b', text: 'Планшет', points: { bonus: 0, speed: 0, games: 0, mobile: 2 } },
      { id: 'c', text: 'Компьютер', points: { bonus: 0, speed: 0, games: 1, mobile: 0 } },
      { id: 'd', text: 'Разные устройства', points: { bonus: 0, speed: 0, games: 1, mobile: 2 } }
    ]
  },
  {
    id: 5,
    question: 'Какой способ пополнения вам удобнее?',
    options: [
      { id: 'a', text: 'Карты российских банков', points: { bonus: 1, speed: 2, games: 0, mobile: 1 } },
      { id: 'b', text: 'СБП (Система быстрых платежей)', points: { bonus: 0, speed: 3, games: 0, mobile: 2 } },
      { id: 'c', text: 'Криптовалюты', points: { bonus: 0, speed: 3, games: 0, mobile: 0 } },
      { id: 'd', text: 'Электронные кошельки (ЮMoney, Qiwi)', points: { bonus: 1, speed: 2, games: 0, mobile: 1 } }
    ]
  },
  {
    id: 6,
    question: 'Насколько важна для вас поддержка на русском языке?',
    options: [
      { id: 'a', text: 'Критически важна, только русский', points: { bonus: 1, speed: 0, games: 0, mobile: 1 } },
      { id: 'b', text: 'Желательна, но не обязательна', points: { bonus: 0, speed: 1, games: 1, mobile: 0 } },
      { id: 'c', text: 'Не важна, владею английским', points: { bonus: 0, speed: 1, games: 2, mobile: 0 } }
    ]
  },
  {
    id: 7,
    question: 'Какой минимальный депозит вас устраивает?',
    options: [
      { id: 'a', text: 'До 500 рублей', points: { bonus: 2, speed: 0, games: 0, mobile: 2 } },
      { id: 'b', text: '500-1000 рублей', points: { bonus: 1, speed: 1, games: 1, mobile: 1 } },
      { id: 'c', text: 'Не важно, готов вносить больше', points: { bonus: 0, speed: 1, games: 2, mobile: 0 } }
    ]
  }
];

export const casinoRecommendations = [
  {
    id: 'vavada',
    name: 'Vavada Casino',
    matchCriteria: { bonus: 2, speed: 2, games: 2, mobile: 2 },
    description: 'Идеальный баланс бонусов, скорости выплат и выбора игр'
  },
  {
    id: 'pinup',
    name: 'Pin-Up Casino',
    matchCriteria: { bonus: 3, speed: 1, games: 3, mobile: 2 },
    description: 'Лучший выбор для любителей щедрых бонусов и большого выбора игр'
  },
  {
    id: 'riobet',
    name: 'Riobet',
    matchCriteria: { bonus: 1, speed: 3, games: 2, mobile: 1 },
    description: 'Оптимальный вариант для тех, кто ценит быстрые выплаты'
  },
  {
    id: 'starda',
    name: 'Starda Casino',
    matchCriteria: { bonus: 2, speed: 3, games: 2, mobile: 3 },
    description: 'Лучшее мобильное казино с мгновенными выплатами'
  },
  {
    id: 'drip',
    name: 'Drip Casino',
    matchCriteria: { bonus: 1, speed: 3, games: 1, mobile: 2 },
    description: 'Идеально для любителей криптовалют и анонимности'
  }
];
